export default __webpack_public_path__ + "static/media/pricing.c58c9883.svg";